// Need to use the React-specific entry point to import createApi
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

// Define a service using a base URL and expected endpoints
export const contactUsData = createApi({
  reducerPath: "contactUsApi",
  baseQuery: fetchBaseQuery({ baseUrl: process.env.REACT_APP_API_URL }),
  endpoints: (builder) => ({
    getBranchStates: builder.query({
      query: () => `branch_state`,
      transformResponse: (response, meta, arg) => response.data,
    }),
    getBranchByStates: builder.query({
      query: (stateID) => ({
        url: `branch_address`,
        params: {
          state_id: stateID,
        },
      }),

      transformResponse: (response, meta, arg) => response.data,
    }),
    contactUs: builder.mutation({
      query: (body) => ({
        url: `contact_us`,
        method: "POST",
        body,
      }),

      transformResponse: (response, meta, arg) => response.data,
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetBranchStatesQuery,
  useGetBranchByStatesQuery,
  useContactUsMutation,
} = contactUsData;
